import { forwardRef } from "react";
import { IconSize } from "../../../classes/enums/ButtonEnum";
import { ToolShape } from "../../../classes/enums/ToolsEnum";
import ToggleButton from "../../../components/toggleButton/ToggleButton";
import "./Tool.css";

const ToolToggle = forwardRef(
  (
    {
      icon = null,
      iconSize = IconSize.LARGE,
      onClick = () => {},
      title,
      text = null,
      isSelected = false,
      noBgColor = false,
      shape = ToolShape.CIRCLE,
      disabled = false,
      className = "",
      ...props
    },
    ref
  ) => {
    return (
      <div className="tool-container">
        <ToggleButton
          ref={ref}
          icon={icon}
          iconSize={iconSize}
          text={text}
          isSmall={false}
          shape={shape}
          noBgColor={noBgColor}
          onClick={onClick}
          isSelected={isSelected}
          disabled={disabled}
          className={className}
          {...props}
        />
        {title && <div className="App-text-small tool-title">{title}</div>}
      </div>
    );
  }
);

ToolToggle.displayName = "ToolToggle";

export default ToolToggle;
